/*
**  rui-popup-notifications.js
**
**  Functions for showing and hiding popup notifications
*/
const CONTAINER_ID = 'rui-popup-notification-container';
const AUTO_DISMISS_SECONDS = 5;
// Show a popup notification
export function ruiShowPopupNotification(config) {
    // Get config values
    const type = (config === null || config === void 0 ? void 0 : config.type.toLowerCase()) || 'information';
    const text = (config === null || config === void 0 ? void 0 : config.text) || '';
    const closeButtonText = (config === null || config === void 0 ? void 0 : config.closeButtonText) || '';
    let autoDismiss = config === null || config === void 0 ? void 0 : config.autoDismiss;
    if (typeof autoDismiss === 'undefined') {
        autoDismiss = true;
    }
    // Get the popup notification container element
    let containerEl = ruiGetPopupNotificationContainer();
    // Create a unique handle that can be used to identify this notification later
    const notificationHandle = 'rui-popup-notification-' + new Date().getTime();
    // Create the popup notification element
    let notificationEl = document.createElement('li');
    notificationEl.setAttribute('id', notificationHandle);
    notificationEl.setAttribute('class', 'rui-popup-notification');
    notificationEl.setAttribute('data-config', config);
    // Add click event handler
    notificationEl.boundClick = ruiPopupNotificationClickHandler.bind(config);
    notificationEl.addEventListener('click', notificationEl.boundClick);
    // Create inner container for notification
    let notificationInnerContainerEl = document.createElement('div');
    notificationInnerContainerEl.setAttribute('class', 'rui-popup-notification-inner-container');
    // Create icon
    let statusIconEl = document.createElement('rui-status-icon');
    statusIconEl.setAttribute('class', 'rui-popup-notification-icon');
    statusIconEl.setAttribute('type', type);
    statusIconEl.setAttribute('size', '24px');
    // Create content
    let contentEl = document.createElement('div');
    contentEl.setAttribute('class', 'rui-popup-notification-content');
    contentEl.innerHTML = text;
    // Create close button if specified
    let closeButtonEl = null;
    if (closeButtonText) {
        closeButtonEl = document.createElement('button');
        closeButtonEl.setAttribute('class', 'rui-popup-notification-button');
        closeButtonEl.innerHTML = closeButtonText;
        closeButtonEl.boundClick = ruiPopupNotificationCloseButtonClickHandler.bind(config);
        closeButtonEl.addEventListener('click', closeButtonEl.boundClick);
    }
    // Add the icon and content to inner container
    notificationInnerContainerEl.appendChild(statusIconEl);
    notificationInnerContainerEl.appendChild(contentEl);
    if (closeButtonEl) {
        notificationInnerContainerEl.appendChild(closeButtonEl);
    }
    // Add the inner container to notification
    notificationEl.appendChild(notificationInnerContainerEl);
    // Add the new popup notification to the list
    containerEl.appendChild(notificationEl);
    // Add the "visible" class to trigger animation on show
    setTimeout(() => {
        notificationEl.setAttribute('class', 'rui-popup-notification visible');
    }, 10);
    // Set auto-dismiss popup notification to automatically close after a pause
    if (autoDismiss) {
        setTimeout(() => {
            ruiHidePopupNotification(notificationHandle);
        }, AUTO_DISMISS_SECONDS * 1000);
    }
    return notificationHandle;
}
// Hide a popup notification 
export function ruiHidePopupNotification(notificationHandle) {
    // Fine the popup notification container element
    let containerEl = document.querySelector('#' + CONTAINER_ID);
    if (containerEl) {
        // Find the notification element
        let notificationEl = containerEl.querySelector('#' + notificationHandle);
        if (notificationEl) {
            // Remove the "visible" class to trigger animation on hide
            notificationEl.setAttribute('class', 'rui-popup-notification');
            // Remove click event handler
            notificationEl.removeEventListener('click', notificationEl.boundClick);
            // Fire custom close event
            let popupNotificationCloseEvent = new CustomEvent('rui-popup-notification-internal-close', {
                detail: notificationHandle,
                bubbles: true,
                composed: true
            });
            dispatchEvent(popupNotificationCloseEvent);
            // Remove the notification element
            setTimeout(() => {
                try {
                    containerEl.removeChild(notificationEl);
                }
                catch { }
            }, 100);
        }
        // Remove the container after the last notification closes
        if (containerEl.children.length < 1) {
            ruiRemovePopupNotificationContainer();
        }
    }
}
// Click event handler
function ruiPopupNotificationClickHandler(e) {
    const clickTree = (e.composedPath() || []).filter(item => item.localName === 'li');
    if (clickTree.length > 0) {
        // Get id of clicked notification 
        const clickedNotificationId = clickTree[0].getAttribute('id');
        // Fire custom click event
        let popupNotificationClickEvent = new CustomEvent('rui-popup-notification-internal-click', {
            detail: clickedNotificationId,
            bubbles: true,
            composed: true
        });
        dispatchEvent(popupNotificationClickEvent);
        // Hide that notification
        ruiHidePopupNotification(clickedNotificationId);
    }
}
// Click event handler for close button within popup
function ruiPopupNotificationCloseButtonClickHandler(e) {
    const clickTree = (e.composedPath() || []).filter(item => item.localName === 'li');
    if (clickTree.length > 0) {
        // Get id of clicked notification 
        const clickedNotificationId = clickTree[0].getAttribute('id');
        // Fire custom click event
        let popupNotificationClickEvent = new CustomEvent('rui-popup-notification-internal-close-button-click', {
            detail: clickedNotificationId,
            bubbles: true,
            composed: true
        });
        dispatchEvent(popupNotificationClickEvent);
        // Hide that notification
        ruiHidePopupNotification(clickedNotificationId);
    }
}
// Find or create the container for all popup notifications
function ruiGetPopupNotificationContainer() {
    let containerElement = document.querySelector('#' + CONTAINER_ID);
    if (!containerElement) {
        containerElement = ruiCreatePopupNotificationContainer();
    }
    return containerElement;
}
// Create the container for all popup notifications and append that to body
function ruiCreatePopupNotificationContainer() {
    let container = document.createElement('ul');
    container.id = 'rui-popup-notification-container';
    return document.body.appendChild(container);
}
// Remove the container for all popup notifications
function ruiRemovePopupNotificationContainer() {
    let containerElement = document.querySelector('#' + CONTAINER_ID);
    if (containerElement) {
        document.body.removeChild(containerElement);
    }
}
